import script from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideMenu.vue?vue&type=script&setup=true&lang=js"

import "./TheSideMenu.vue?vue&type=style&index=0&id=2485b17a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2485b17a"]])

export default __exports__